import { type PropsWithChildren } from 'react';

export const Label = ({ children }: PropsWithChildren) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  (<>{children}</>)
);

Label['displayName'] = 'MultiMeterBarChart.Label';
